<div class="min-h-screen bg-gray-50 dark:bg-gray-900 pb-20">
  <div class="max-w-3xl mx-auto px-4 pt-3 pb-4">

    <div
      *ngIf="semContexto"
      class="mb-4 rounded-xl border border-amber-200 dark:border-amber-800 bg-amber-50 dark:bg-amber-950/20 p-4 text-sm text-amber-900 dark:text-amber-200">
      Selecione um contexto para visualizar o plano de ensino.
    </div>

    <ng-container *ngIf="!semContexto">

        <!-- <section class="mb-4 px-1">
             <h1 class="text-xl font-bold text-gray-900 dark:text-gray-100">Plano de ensino</h1>
           </section> -->


      <section *ngIf="componentes.length > 1" class="mb-4">
        <div class="flex items-center justify-center gap-3 bg-white dark:bg-gray-800 rounded-xl border border-gray-200 dark:border-gray-700 px-3 py-2">
          <button
            type="button"
            (click)="prev()"
            [disabled]="!podePrev"
            [class.opacity-30]="!podePrev"
            [class.cursor-not-allowed]="!podePrev"
            class="p-1 transition-opacity"
            aria-label="Componente anterior">
            <lucide-icon name="chevron-left" [size]="22" class="text-green-600 dark:text-green-400"></lucide-icon>
          </button>

          <div class="relative flex-1 text-center" data-nav-dropdown>
            <button
              type="button"
              (click)="dropdownAberto = !dropdownAberto"
              class="text-sm font-medium text-gray-900 dark:text-gray-100 inline-flex items-center gap-1 max-w-full truncate">
              <span class="truncate">{{ labelAtual }}</span>
              <lucide-icon name="chevron-down" [size]="15" class="shrink-0 text-gray-500 dark:text-gray-400"></lucide-icon>
            </button>

            <div
              *ngIf="dropdownAberto"
              class="absolute left-1/2 -translate-x-1/2 mt-2 w-64 bg-white dark:bg-gray-800 rounded-lg shadow-xl border border-gray-200 dark:border-gray-700 z-50 max-h-56 overflow-y-auto">
              <button
                *ngFor="let comp of componentes"
                type="button"
                (click)="selecionarComponente(comp); dropdownAberto = false"
                [class.bg-blue-50]="itemAtual?.id === comp.id"
                [class.dark:bg-blue-900]="itemAtual?.id === comp.id"
                class="w-full text-left px-4 py-2.5 hover:bg-gray-50 dark:hover:bg-gray-700 text-sm text-gray-800 dark:text-gray-200">
                {{ comp.descricao || comp.nome }}
              </button>
            </div>
          </div>

          <button
            type="button"
            (click)="next()"
            [disabled]="!podeNext"
            [class.opacity-30]="!podeNext"
            [class.cursor-not-allowed]="!podeNext"
            class="p-1 transition-opacity"
            aria-label="Próximo componente">
            <lucide-icon name="chevron-right" [size]="22" class="text-green-600 dark:text-green-400"></lucide-icon>
          </button>
        </div>
      </section>

      <div *ngIf="carregando" class="rounded-xl border border-dashed border-gray-200 dark:border-gray-700 px-4 py-6 text-sm text-gray-500 dark:text-gray-400 text-center">
        <lucide-icon name="loader-2" [size]="20" class="inline-block animate-spin mr-2"></lucide-icon>
        Carregando plano de ensino...
      </div>

      <div
        *ngIf="!carregando && !campoAdicional"
        class="rounded-xl border border-dashed border-gray-200 dark:border-gray-700 px-4 py-6 text-sm text-gray-500 dark:text-gray-400 text-center">
        Não há plano de ensino configurado para esta disciplina.
      </div>

      <div *ngIf="!carregando && campoAdicional" class="bg-white dark:bg-gray-800 rounded-xl border border-gray-200 dark:border-gray-700 p-4">
        <app-cpa-grid-bridge [config]="campoAdicional"></app-cpa-grid-bridge>
      </div>

    </ng-container>
  </div>
</div>
